const elements = [
  { icon: 'ri-search-eye-line', text: 'Диагностика компетенций' },
  { icon: 'ri-book-open-line', text: 'Обучение' },
  { icon: 'ri-tools-line', text: 'Практика' },
  { icon: 'ri-user-heart-line', text: 'Наставничество' },
  { icon: 'ri-chat-check-line', text: 'Обратная связь' },
  { icon: 'ri-task-line', text: 'Развивающие задачи' },
  { icon: 'ri-line-chart-line', text: 'Оценка прогресса' },
  { icon: 'ri-road-map-line', text: 'Индивидуальные планы развития' },
  { icon: 'ri-vip-crown-line', text: 'Подготовка кадрового резерва' },
  { icon: 'ri-compass-3-line', text: 'Сопровождение' },
];

export default function WhatIsDevelopment() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие персонала — это больше, чем обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Между обучением и развитием есть принципиальная разница, и именно она определяет, приведут ли вложения компании в обучение к реальным изменениям в работе.
        </p>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-6 md:p-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-book-open-line text-xl text-teal-700"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Обучение</h3>
              </div>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Сотрудник получает знания и навыки: разбирает инструменты, модели и подходы на тренинге, вебинаре или в рамках курса. Обучение отвечает на вопрос «что нужно знать и уметь».
              </p>
            </div>

            <div className="bg-teal-50 rounded-xl border border-teal-100 p-6 md:p-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-seedling-line text-xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Развитие</h3>
              </div>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Сотрудник начинает применять новые компетенции в работе и постепенно расширяет свою ответственность. Развитие отвечает на вопрос «как новое становится частью рабочего поведения».
              </p>
            </div>

            <div className="border-l-4 border-teal-600 bg-gray-50 rounded-r-xl p-6 md:p-8">
              <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
                Обучение является частью развития персонала, но само по себе не гарантирует изменения в работе сотрудника.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-6">
              Что может включать системное развитие
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {elements.map((el, i) => (
                <div key={i} className="flex items-start gap-3 bg-white rounded-xl border border-gray-100 p-4">
                  <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${el.icon} text-teal-700`}></i>
                  </div>
                  <p className="text-sm text-gray-700 leading-relaxed">{el.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}